import { render, staticRenderFns } from "./tradeflow-info.vue?vue&type=template&id=73f3cf82&"
import script from "./tradeflow-info.vue?vue&type=script&lang=js&"
export * from "./tradeflow-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tradeflow-info.vue"
export default component.exports